import { Injectable } from '@angular/core';
import { TranslocoUtils } from '@aodocs/shared-translation';
import { locale } from 'dayjs';

@Injectable()
export class InternationalizationService {
  currentLocale: string;

  constructor() {
    this.currentLocale = this.getLocale();
  }

  getLocale(): string {
    const languageOrLocale = navigator.language;
    const parsing = /([a-z]{2})-([A-Z]{2})/.exec(languageOrLocale);
    this.setDayjsLocale(languageOrLocale);
    if (parsing) {
      return languageOrLocale;
    } else {
      return TranslocoUtils.LANG_TO_LOCALE_MAPPING[languageOrLocale as (typeof TranslocoUtils.LANGS)[number]];
    }
  }

  private setDayjsLocale(language: string): void {
    import(`dayjs/locale/${language.toLowerCase()}`)
      .catch(() => import(`dayjs/locale/${this.getLanguageFromLocale(language)}`))
      .then(({ name }) => locale(name));
  }

  private getLanguageFromLocale(_locale: string): string {
    return /([a-z]{2})-([A-Z]{2})/.exec(_locale)?.[1] || TranslocoUtils.DEFAULT_LANG;
  }
}
